var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67601 20.8623L17.3153 30.8568C17.6398 31.1616 17.802 31.314 18 31.314C18.198 31.314 18.3602 31.1616 18.6847 30.8568L18.6847 30.8568L29.324 20.8623C32.2582 18.1059 32.6146 13.5699 30.1467 10.3891L29.6827 9.79101C26.7304 5.98587 20.8044 6.62402 18.73 10.9705C18.437 11.5844 17.563 11.5844 17.27 10.9705C15.1956 6.62402 9.26959 5.98587 6.31732 9.79101L5.85328 10.3891C3.38542 13.5699 3.74175 18.1059 6.67601 20.8623Z",
    stroke: "#1B1836",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.24272ec03ee8d9e3c7bff3e16a09b93b.svg";
export { ForwardRef as ReactComponent };